import {
  LOAD_CASES,
  LOAD_UPDATED_CASES,
  LOAD_COMMISSION_INFO,
  LOAD_CASE_NOTES_INFO
} from "./actions";

const initialState = {
  currentCases: [],
  currentPage: 0,
  totalCases: 0,
  totalPages: 0,
  sortValue: "",
  sortOrder: "",
  editValue: "",
  CommissionInfo: {
    correctiveEvents:[],
    corrective_events:[]
  },
  txtCaseNotes: ""
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case LOAD_CASES:
      return {
        ...state,
        currentCases: action.cases,
        currentPage: action.currentPage,
        totalCases: action.totalCases,
        totalPages: action.totalPages,
        sortValue: action.sortValue,
        sortOrder: action.sortOrder
      };
    case LOAD_UPDATED_CASES:
      return {
        ...state,
        editValue: action.value
      };
    case LOAD_COMMISSION_INFO:
      return {
        ...state,
        CommissionInfo: action.CommissionInfo
      };

    case LOAD_CASE_NOTES_INFO:
      return {
        ...state,
        txtCaseNotes: action.txtCaseNotes
      };  
    default:
      return state;
  }
};

export default reducer;



// WEBPACK FOOTER //
// ./src/components/CaseSelector/store/reducer.js